import DOM from '../../utils/dom';
import { SYSTEM_EVENTS } from "../../events/events";
import Event from '../../utils/event'
import IToasterOptions from "../../services/toaster/toaster_options_interface";
import GameItemComponentController from "../game_item/game_item_component_controller";
import ToasterBaseComponent from "../../base/toaster_base_component";
import { BaseComponentParams } from '../../base/base_component_interface';

const view = require('./view/idle_recommendations_view.html');

const IDLE_RECOMMENDATIONS_SELECTORS = {
    BACKGROUND_IMAGE: 'toaster-background-image',
    GAME_ITEM_CONTAINER: 'cgp-game-item-container',
    GAME_DETAILS: 'cgp-idle-recommendations-game-details'
};

const IDLE_RECOMMENDATIONS_TRANSLATIONS = {
    TITLE: 'idle_recommendations_title',
    SECOND_TITLE: 'idle_recommendations_second_title',
    PLAY_BTN: 'game_item_play_btn', // same key as the one for game item play btn
};

interface IdleRecommendationComponentParams extends BaseComponentParams {
    recommendedGameInfo: object;
}

export default class IdleRecommendationsComponent extends ToasterBaseComponent {

    recommendedGameType: number;
    dataAnalytics_numberOfAppearances: number;

    showAsToaster(options: IToasterOptions) {

        const originalOnClosed = options.onClosed;
        options.onClosed = () => {
            this._onClosedHandler();
            originalOnClosed();
        };
        super.showAsToaster(options);

        this._sendAnalytics({action: 'view', label: this.recommendedGameType, value: 1 + this.dataAnalytics_numberOfAppearances});
    }

    _onClosedHandler = () => { };

    // We have two different types of close analytics: one for clicking the idle rec's X btn and one for launching a game(NOT the one in idle) while the idle is active.
    _sendOnCloseAnalytics = () => {
        this._sendAnalytics({action: 'click_close_button', label: this.recommendedGameType});
    };

    _sendOpenedAnotherGameWhileIdleIsActiveAnalytics = () => {
        this._sendAnalytics({action: 'launched_other_game', label: this.recommendedGameType});
    };

    _dontSendOnCloseAnalytics = () => { };

    init(params: any) {
        params = params || {} as IdleRecommendationComponentParams;
        this._onClosedHandler = this._sendOnCloseAnalytics;

        this.recommendedGameType = params.recommendedGameInfo.gameType;
        this.dataAnalytics_numberOfAppearances = params.dataAnalytics_numberOfAppearances;

        super.init(params);

        this.setHTML(
            this.bake(view, {
                title: this.serviceFactory.languageService().translation(IDLE_RECOMMENDATIONS_TRANSLATIONS.TITLE),
                second_title: this.serviceFactory.languageService().translation(IDLE_RECOMMENDATIONS_TRANSLATIONS.SECOND_TITLE),
            }));

        this._injectGameItemComponent(params.recommendedGameInfo);
        this._setBackgroundImage();
    }

    private _injectGameItemComponent(recommendedGameInfo: any): void {
        const gameItemComponent = GameItemComponentController.create({
            gameData: Object.assign({ gametypeid: recommendedGameInfo.gameType }, recommendedGameInfo),
            playBtnText: IDLE_RECOMMENDATIONS_TRANSLATIONS.PLAY_BTN,
            onClicked: this._onPlayRecommendedGameHandler.bind(this, recommendedGameInfo)
        }).start();

        DOM.append(this.getDOMElementByClassName(IDLE_RECOMMENDATIONS_SELECTORS.GAME_DETAILS), gameItemComponent.getEl());
    }

    private _onPlayRecommendedGameHandler(recommendedGameInfo: any) {
        this._onClosedHandler = this._dontSendOnCloseAnalytics;

        this.closeToaster();

        this.serviceFactory.gameService().openRealGame({ gameType: recommendedGameInfo.gameType });

        this._sendAnalytics({action: 'click_play', label: this.recommendedGameType});
    }

    private _setBackgroundImage() {
        const divElement = DOM.createElement('div');
        DOM.addClass(divElement, IDLE_RECOMMENDATIONS_SELECTORS.BACKGROUND_IMAGE);
        DOM.append(this.getDOMElementByClassName(IDLE_RECOMMENDATIONS_SELECTORS.GAME_ITEM_CONTAINER), divElement);
    }

    _sendAnalytics(analyticsData): void{
        const analyticsObject = {
            category: 'idleRecommendations'
        };

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, Object.assign(analyticsObject, analyticsData));
  }

    public closeToasterWhenOpeningAnotherGame(){
        this._onClosedHandler = this._sendOpenedAnotherGameWhileIdleIsActiveAnalytics;

        this.closeToaster();
    }
}